import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const CampaignRemoveContributorNotifCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `(ت)قام ${sender?.name} بحذفك من قائمة المشاركين و كذلك قناة المشاركة الخاصة بحملة ترويجية `
          : `${sender?.name} has removed you from his(her) project campaign contributors list and the associated channel`
      }
    />
  )
}

export default CampaignRemoveContributorNotifCover
